(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["the-haiku-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MARK = '<svg class="hg-card-mark" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10 2c1.1 0 2 .9 2 2 0 .4-.1.7-.3 1 .3-.2.6-.3 1-.3 1.1 0 2 .9 2 2s-.9 2-2 2c-.4 0-.7-.1-1-.3.2.3.3.6.3 1 0 1.1-.9 2-2 2s-2-.9-2-2c0-.4.1-.7.3-1-.3.2-.6.3-1 .3-1.1 0-2-.9-2-2s.9-2 2-2c.4 0 .7.1 1 .3-.2-.3-.3-.6-.3-1 0-1.1.9-2 2-2z"/><circle cx="10" cy="10" r="1.5"/></svg>';
  var ARROW = '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4"/></svg>';
  var REDO = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>';
  var BACK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>';

  function lines(str) {
    /* Les haïkus Floraïku séparent les vers par « | » (parfois par retours ligne). */
    return String(str || '').split(/\r?\n|\s*\|\s*/).map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function haikuHTML(str, name) {
    var nm = String(name || '').trim().toLowerCase();
    var ls = lines(str);
    function span(l) {
      /* Une strophe égale au nom du parfum passe en accent (orange). */
      var cls = (nm && String(l).trim().toLowerCase() === nm) ? ' class="hg-line-accent"' : '';
      return '<span' + cls + '>' + l + '</span>';
    }
    if (ls.length <= 1) return span(ls[0] || str || '');
    return ls.map(span).join('');
  }
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      // déterministe-léger : pas de Math.random interdit ? Math.random est autorisé dans le navigateur.
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function HaikuGuide(root) {
    var el = this;
    el.root = root;
    el.overline = root.dataset.overline || 'The haiku guide';
    el.heading = root.dataset.heading || 'Which haïku speaks to you?';
    el.count = parseInt(root.dataset.count || '6', 10);
    el.shuffleLabel = root.dataset.shuffleLabel || 'Read other haïkus';
    el.restartLabel = root.dataset.restartLabel || 'Start again';
    el.ctaLabel = root.dataset.ctaLabel || 'Discover this perfume';
    el.resultOverline = root.dataset.resultOverline || 'Your haïku';
    el.moodPlaceholder = root.dataset.moodPlaceholder || 'Describe a mood, a place, a feeling…';
    el.moodButton = root.dataset.moodButton || 'Reveal my haïku';
    el.orLabel = root.dataset.orLabel || 'or choose a haïku';
    var sid = root.dataset.sectionId || '';
    var descTpl = document.getElementById('hg-desc-' + sid);
    el.description = descTpl ? descTpl.innerHTML.trim() : '';
    var pj = document.getElementById('hg-products-' + sid);
    var products = {};
    try { products = pj ? JSON.parse(pj.textContent) : {}; } catch (e) { products = {}; }
    el.all = Object.keys(products).map(function (h) {
      var p = products[h] || {}; p.handle = h; return p;
    }).filter(function (p) { return p.haiku; });
    el._render();
  }

  HaikuGuide.prototype._render = function () {
    this.root.innerHTML = '<div class="hg-inner"><div class="hg-widget" data-hg-inner></div></div>';
    this.inner = this.root.querySelector('[data-hg-inner]');
    this._renderQuiz();
  };

  HaikuGuide.prototype._renderQuiz = function () {
    var self = this;
    self.root.classList.remove('hg-showing-result');
    if (!self.all.length) {
      self.inner.innerHTML = '<div class="hg-overline">' + self.overline + '</div>' +
        '<h2 class="hg-title">' + self.heading + '</h2>' +
        '<p class="hg-empty">No haiku found yet. Add a haiku metafield to your perfumes to enable this guide.</p>';
      return;
    }
    self.pick = shuffle(self.all).slice(0, Math.min(self.count, self.all.length));
    var cards = self.pick.map(function (p, i) {
      return '<button class="hg-card" type="button" data-hg-pick="' + i + '">' +
        MARK + '<div class="hg-card-haiku">' + haikuHTML(p.haiku) + '</div>' +
      '</button>';
    }).join('');
    self.inner.innerHTML =
      '<div class="hg-overline">' + self.overline + '</div>' +
      '<h2 class="hg-title">' + self.heading + '</h2>' +
      '<div class="hg-lede">' + self.description + '</div>' +
      '<form class="hg-mood" data-hg-mood>' +
        '<input class="hg-mood-input" type="text" name="mood" placeholder="' + self.moodPlaceholder + '" autocomplete="off" aria-label="' + self.moodPlaceholder + '">' +
        '<button class="button" type="submit">' + self.moodButton + ARROW + '</button>' +
      '</form>' +
      '<div class="hg-or"><span>' + self.orLabel + '</span></div>' +
      '<div class="hg-cards">' + cards + '</div>' +
      (self.all.length > self.count ?
        '<div class="hg-actions"><button class="hg-shuffle" type="button" data-hg-shuffle>' + REDO + '<span>' + self.shuffleLabel + '</span></button></div>' : '');
    self.inner.querySelectorAll('[data-hg-pick]').forEach(function (b) {
      b.addEventListener('click', function () { self._reveal(self.pick[parseInt(b.dataset.hgPick, 10)]); });
    });
    var mform = self.inner.querySelector('[data-hg-mood]');
    if (mform) mform.addEventListener('submit', function (e) {
      e.preventDefault();
      var val = (mform.querySelector('.hg-mood-input').value || '').trim();
      if (val) self._matchMood(val);
    });
    var sh = self.inner.querySelector('[data-hg-shuffle]');
    if (sh) sh.addEventListener('click', function () { self._renderQuiz(); self._scrollTop(); });
  };

  /* Matching local du mood : recoupe les mots saisis avec haïku + notes + nom du parfum. */
  HaikuGuide.prototype._matchMood = function (text) {
    var STOP = { 'the':1,'and':1,'for':1,'with':1,'your':1,'you':1,'are':1,'this':1,'that':1,'feel':1,'feeling':1,'mood':1,
      'les':1,'des':1,'une':1,'mon':1,'qui':1,'pour':1,'avec':1,'dans':1,'sur':1,'mes':1,'ses':1,'est':1,'une':1 };
    var q = String(text).toLowerCase().split(/[^a-z0-9à-ÿ]+/).filter(function (w) { return w.length >= 3 && !STOP[w]; });
    var best = null, bestScore = -1;
    this.all.forEach(function (p) {
      var hay = ((p.haiku || '') + ' ' + (p.notes || '') + ' ' + (p.title || '')).toLowerCase();
      var s = 0;
      q.forEach(function (w) { if (hay.indexOf(w) !== -1) s++; });
      if (s > bestScore) { bestScore = s; best = p; }
    });
    /* Aucun recoupement → on offre un vers au hasard (sérendipité poétique). */
    if (!best || bestScore <= 0) { best = this.all[Math.floor(Math.random() * this.all.length)]; }
    this._reveal(best);
  };

  HaikuGuide.prototype._reveal = function (p) {
    var self = this;
    self.root.classList.add('hg-showing-result');
    var notes = p.notes ? '<div class="hg-result-notes">' + p.notes.split('·').map(function (s) { return '<span class="hg-note-item">' + s.trim() + '</span>'; }).join('') + '</div>' : '';
    var media = p.image ? '<div class="hg-result-media"><img src="' + p.image + '" alt="' + p.title + '" loading="lazy"></div>' : '<div class="hg-result-media"></div>';
    self.inner.innerHTML =
      '<div class="hg-result">' +
        media +
        '<div class="hg-result-body">' +
          '<div class="hg-result-overline">' + self.resultOverline + '</div>' +
          '<div class="hg-sep"></div>' +
          '<p class="hg-result-haiku">' + haikuHTML(p.haiku, p.title) + '</p>' +
          '<div class="hg-sep"></div>' +
          '<h2 class="hg-result-name">' + (p.title || '').toUpperCase() + '</h2>' +
          (notes ? '<div class="hg-sep"></div>' + notes : '') +
          '<div class="hg-result-actions">' +
            '<a class="button" href="' + (p.url || '#') + '">' + self.ctaLabel + ARROW + '</a>' +
            '<button class="hg-restart" type="button" data-hg-restart>' + BACK + '<span>' + self.restartLabel + '</span></button>' +
          '</div>' +
        '</div>' +
      '</div>';
    var rb = self.inner.querySelector('[data-hg-restart]');
    if (rb) rb.addEventListener('click', function () { self._renderQuiz(); self._scrollTop(); });
    self._scrollTop();
  };

  HaikuGuide.prototype._scrollTop = function () {
    try {
      var rect = this.root.getBoundingClientRect();
      var top = (window.pageYOffset || document.documentElement.scrollTop) + rect.top - 16;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    } catch (e) {}
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-hg-root]').forEach(function (el) {
      if (!el.dataset.hgInit) { el.dataset.hgInit = '1'; new HaikuGuide(el); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-hg-root]');
    if (root) { delete root.dataset.hgInit; new HaikuGuide(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-olfactive-guide"] && !Shopify.designMode) return;
  try {
    
(function () {

  var FAMILIES = [
    { id: 'leather',   label: 'Leather',    hint: 'Suede, smoked leather, animalic' },
    { id: 'woody',     label: 'Woody',      hint: 'Cedar, sandalwood, vetiver' },
    { id: 'floral',    label: 'Floral',     hint: 'Rose, tuberose, iris' },
    { id: 'oriental',  label: 'Oriental',   hint: 'Oud, amber, resins' },
    { id: 'spicy',     label: 'Spicy',      hint: 'Saffron, cardamom, pepper' },
    { id: 'citrus',    label: 'Citrus',     hint: 'Bergamot, neroli, zesty fruits' },
    { id: 'aromatic',  label: 'Aromatic',   hint: 'Lavender, sage, juniper' },
    { id: 'gourmand',  label: 'Gourmand',   hint: 'Tonka, vanilla, honey' },
    { id: 'green',     label: 'Green',      hint: 'Fern, moss, leaves' },
    { id: 'musky',     label: 'Musky',      hint: 'White musk, skin, ambrette' },
    { id: 'smoky',     label: 'Smoky',      hint: 'Birch, incense, tobacco' },
    { id: 'marine',    label: 'Marine',     hint: 'Sea spray, salt, seaweed' }
  ];

  // Hand-tuned affinity scores per existing perfume handle. New products that
  // are not listed here automatically get an affinity inferred from their
  // notes string (see inferAffinity below). To fine-tune a new product, just
  // add an entry here.
  // FLORAIKU : pas d'affinités codées par handle (les handles Memo ne s'appliquent pas ici).
  // Chaque parfum est scoré AUTOMATIQUEMENT depuis ses notes (metafield global.notes /
  // custom.product_scent) via inferAffinity + FAMILY_KEYWORDS (FR + EN).
  // Pour forcer/affiner un parfum précis, ajoute : 'handle-du-parfum': { woody:9, floral:6, ... }.
  var AFFINITY_BY_HANDLE = {};

  // Keyword tables (FR + EN) used to infer family affinity from a perfume's
  // notes string when no explicit affinity is set for its handle. Adding a
  // new perfume to the collection? It auto-scores via these keywords.
  var FAMILY_KEYWORDS = {
    leather:  ['cuir', 'leather', 'su\u00e8de', 'suede', 'daim'],
    woody:    ['bois', 'wood', 'c\u00e8dre', 'cedar', 'santal', 'sandalwood', 'v\u00e9tiver', 'vetiver', 'amyris', 'cypriol'],
    floral:   ['rose', 'jasmin', 'jasmine', 'fleur', 'flower', 'tub\u00e9reuse', 'tuberose', 'iris', 'gard\u00e9nia', 'gardenia', 'osmanthus', 'oranger', 'blossom'],
    oriental: ['oud', 'ambre', 'amber', 'r\u00e9sine', 'resin', 'encens', 'incense', 'patchouli'],
    spicy:    ['poivre', 'pepper', 'cardamome', 'cardamom', 'safran', 'saffron', 'cannelle', 'cinnamon', 'gingembre', 'ginger', 'coriandre', 'coriander'],
    citrus:   ['citron', 'lime', 'lemon', 'bergamote', 'bergamot', 'mandarine', 'mandarin', 'pamplemousse', 'grapefruit', 'n\u00e9roli', 'neroli', 'c\u00e9drat', 'cedrat'],
    aromatic: ['lavande', 'lavender', 'sauge', 'sage', 'geni\u00e8vre', 'genevrier', 'juniper', 'mat\u00e9', 'mate', 'sclar\u00e9e', 'clary'],
    gourmand: ['vanille', 'vanilla', 'tonka', 'miel', 'honey', 's\u00e9same', 'sesame', 'datte', 'date', 'cashmeran', 'p\u00eache', 'peach'],
    green:    ['vert', 'green', 'feuille', 'leaf', 'mousse', 'moss', 'foug\u00e8re', 'fern', 'galbanum', 'foin', 'tomate', 'tomato'],
    musky:    ['musc', 'musk', 'ambrette'],
    smoky:    ['bouleau', 'birch', 'tabac', 'tobacco', 'fum\u00e9', 'smoky', 'myrrhe', 'myrrh'],
    marine:   ['marin', 'marine', 'mer', 'sea', 'salt', 'sel', 'algue', 'seaweed', 'embrun']
  };

  function inferAffinity(notes) {
    var s = String(notes || '').toLowerCase();
    var aff = {};
    Object.keys(FAMILY_KEYWORDS).forEach(function (fam) {
      var hits = 0;
      FAMILY_KEYWORDS[fam].forEach(function (kw) {
        if (s.indexOf(kw) !== -1) hits++;
      });
      if (hits > 0) aff[fam] = Math.min(10, 4 + hits * 3);
    });
    // If nothing matched, give a flat baseline so the perfume can still surface
    if (Object.keys(aff).length === 0) {
      aff = { floral:3, woody:3, citrus:3, oriental:3, spicy:3, gourmand:3 };
    }
    return aff;
  }

  // Build a perfume entry from one product in the collection JSON. Affinity
  // comes from AFFINITY_BY_HANDLE if set (precise), else inferred from notes.
  function buildPerfume(handle, p) {
    return {
      handle: handle,
      name: (p.title || handle).toUpperCase(),
      tagline: p.tagline || '',
      notes: p.notes || '',
      affinity: AFFINITY_BY_HANDLE[handle] || inferAffinity(p.notes),
      // `rank` mirrors the collection iteration order. The merchant should
      // set the perfumes collection sort to "Best selling" in Shopify Admin
      // so this lines up with sales velocity. Used as the primary tiebreaker
      // in computeMatches so bestsellers surface first when scores tie.
      rank: typeof p.rank === 'number' ? p.rank : 9999
    };
  }

  function buildPerfumesFromProducts(products) {
    if (!products) return [];
    var list = [];
    Object.keys(products).forEach(function (handle) {
      list.push(buildPerfume(handle, products[handle] || {}));
    });
    return list;
  }

  var ICONS = {
    leather:  '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6c3-2 7-2 10-1s4 4 3 7-5 5-9 4S1 12 3 6z"/><path d="M7 9c1-.5 2-.5 3 0M10 12c1-.3 2-.3 3 .2"/></svg>',
    woody:    '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2v16M10 6l-4-3M10 9l4-3M10 12l-4-3M10 15l4-3"/></svg>',
    floral:   '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="2"/><path d="M10 8V4M10 12v4M8 10H4M12 10h4M7 7L4.5 4.5M13 7l2.5-2.5M7 13l-2.5 2.5M13 13l2.5 2.5"/></svg>',
    oriental: '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 16c0-4 3-7 6-7s6 3 6 7"/><path d="M10 9V3M8 5l2-2 2 2"/><circle cx="10" cy="14" r="1"/></svg>',
    spicy:    '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 5s1 3 4 4 6 0 6 0-1 3-4 5-8 2-9-1 0-6 3-8z"/></svg>',
    citrus:   '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="6"/><path d="M10 4v12M4 10h12M6 6l8 8M14 6l-8 8"/></svg>',
    aromatic: '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M10 17V7c0-2 1-3 3-3s3 1 3 3"/><path d="M10 11c-3 0-5-1-5-4M10 14c-3 0-5-1-5-4"/></svg>',
    gourmand: '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 10c0-3 3-6 6-6s6 3 6 6v1c0 3-2 5-6 5s-6-2-6-5z"/><path d="M7 10c1 1 2 1 3 0M10 10c1 1 2 1 3 0"/></svg>',
    green:    '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M10 17C10 11 5 7 3 6c0 6 3 11 7 11z"/><path d="M10 17c0-6 5-10 7-11 0 6-3 11-7 11z"/></svg>',
    musky:    '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="5"/><circle cx="10" cy="10" r="2"/><path d="M10 3v2M10 15v2M3 10h2M15 10h2"/></svg>',
    smoky:    '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7c2-2 5-1 6 1s4 2 6 0M4 11c2-2 5-1 6 1s4 2 6 0M4 15c2-2 5-1 6 1"/></svg>',
    marine:   '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8c2-2 4-2 5 0s3 2 5 0 4-2 5 0"/><path d="M3 12c2-2 4-2 5 0s3 2 5 0 4-2 5 0"/><path d="M3 16c2-2 4-2 5 0s3 2 5 0 4-2 5 0"/></svg>'
  };

  var ARROW = '<svg class="ff-btn-arrow" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4"/></svg>';
  /* FLORAIKU : motif fleur (au lieu de la coche) comme indicateur de sélection */
  var CHECK = '<svg class="ff-card-check-icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10 2c1.1 0 2 .9 2 2 0 .4-.1.7-.3 1 .3-.2.6-.3 1-.3 1.1 0 2 .9 2 2s-.9 2-2 2c-.4 0-.7-.1-1-.3.2.3.3.6.3 1 0 1.1-.9 2-2 2s-2-.9-2-2c0-.4.1-.7.3-1-.3.2-.6.3-1 .3-1.1 0-2-.9-2-2s.9-2 2-2c.4 0 .7.1 1 .3-.2-.3-.3-.6-.3-1 0-1.1.9-2 2-2z"/><circle cx="10" cy="10" r="1.5"/></svg>';

  function computeMatches(selected, topN, perfumes) {
    if (!selected.length) return [];
    var src = perfumes || [];
    var scored = src.map(function (p) {
      var raw = 0;
      selected.forEach(function (id) { raw += (p.affinity[id] || 0); });
      return { handle: p.handle, name: p.name, tagline: p.tagline, notes: p.notes, score: raw, rank: p.rank };
    });
    // Sort: best score first, bestseller rank as tiebreaker, then alpha.
    scored.sort(function (a, b) {
      return b.score - a.score
          || (a.rank || 9999) - (b.rank || 9999)
          || a.name.localeCompare(b.name);
    });
    var best = scored[0].score;
    var targetTop = 88 + Math.floor(Math.random() * 10);
    scored.forEach(function (s) {
      s.match = best > 0 ? Math.max(42, Math.round((s.score / best) * targetTop)) : 0;
    });
    return scored.slice(0, topN);
  }

  function bottleHTML(p, products) {
    var pd = products[p.handle];
    if (pd && pd.image) {
      return '<img src="' + pd.image + '" alt="' + p.name + '" loading="lazy">';
    }
    return '<div class="ff-bottle-placeholder"><div class="ff-bottle-cap"></div><div class="ff-bottle-body"><div class="ff-bottle-brand">FLORAÏKU</div><div class="ff-bottle-name">' + p.name + '</div></div></div>';
  }

  function resultRowHTML(p, rank, products, showMatch, t) {
    var pd = products[p.handle];
    var url = (pd && pd.url) ? pd.url : ('/products/' + p.handle);
    var matchHTML = showMatch
      ? '<div class="ff-result-match">' +
          '<div class="ff-result-pct">' + p.match + '%</div>' +
          '<div class="ff-result-pct-label">' + ((t && t.match) || 'Match') + '</div>' +
          '<div class="ff-result-bar"><div class="ff-result-bar-fill" style="width:' + p.match + '%"></div></div>' +
        '</div>'
      : '';
    return '<a class="ff-result-row' + (rank === 0 ? ' is-top' : '') + (showMatch ? '' : ' ff-no-match') + '" href="' + url + '">' +
      '<div class="ff-bottle">' + bottleHTML(p, products) + '</div>' +
      '<div class="ff-result-meta">' +
        '<div class="ff-result-coll">' + p.tagline + '</div>' +
        '<div class="ff-result-name">' + p.name + '</div>' +
        '<div class="ff-result-notes">' + p.notes.split('\u00b7').map(function(s){ return '<span class="ff-note-item">' + s.trim() + '</span>'; }).join('') + '</div>' +
      '</div>' +
      matchHTML +
    '</a>';
  }

  function quizHTML(overline, heading, description, selected, families, t) {
    var count = selected.length;
    return '<div class="ff-overline">' + overline + '</div>' +
      '<h2 class="ff-title">' + heading + '</h2>' +
      '<div class="ff-lede">' + description + '</div>' +
      '<p class="ff-step">' + t.multipleChoices + '</p>' +
      '<div class="ff-cards">' +
        families.map(function (f) {
          var on = selected.indexOf(f.id) !== -1;
          var iconSvg = ICONS[f.id] || '';
          return '<button class="ff-card' + (on ? ' is-on' : '') + '" type="button" aria-pressed="' + on + '" data-family-id="' + f.id + '">' +
            '<span class="ff-card-check">' + CHECK + '</span>' +
            '<span class="ff-card-symbol">' + iconSvg + '</span>' +
            '<div class="ff-card-label">' + f.label + '</div>' +
            '<div class="ff-card-hint">' + f.hint.split(',').map(function(s){ var x = s.trim(); return '<span class="ff-hint-item">' + x.charAt(0).toUpperCase() + x.slice(1) + '</span>'; }).join('') + '</div>' +
          '</button>';
        }).join('') +
      '</div>' +
      '<div class="ff-actions">' +
        '<div class="ff-count"><strong>' + count + '</strong> ' + (count === 1 ? t.familySingular : t.familyPlural) + '</div>' +
        '<button class="button" type="button" data-ff-submit' + (count === 0 ? ' disabled' : '') + ' aria-label="' + t.revealAria + '">' + t.revealAria + ARROW + '</button>' +
      '</div>';
  }

  function resultsHTML(overline, selected, matches, ctaUrl, ctaLabel, products, compact, resultsHeading, restartLabel, resultsNote, families, t) {
    var labels = selected.map(function (id) {
      var f = families.filter(function (x) { return x.id === id; })[0];
      return f ? f.label.toLowerCase() : '';
    }).filter(Boolean);
    var subtitle = compact ? '' : ('<em>' + t.forPreposition + ' ' + labels.slice(0, 3).join(' \u00b7 ') + (labels.length > 3 ? '\u2026' : '') + '</em>');
    var showMatch = matches.length > 1 && !matches.every(function(m) { return m.match === matches[0].match; });
    var topMatch = matches[0];
    var topUrl = ctaUrl ||
      (topMatch && products[topMatch.handle] && products[topMatch.handle].url) ||
      (topMatch ? '/products/' + topMatch.handle : '/collections/perfumes');
    return '<div class="ff-results-head">' +
        '<div><div class="ff-overline">' + overline + '</div><h2 class="ff-title">' + resultsHeading + subtitle + '</h2></div>' +
      '</div>' +
      '<div class="ff-result-list">' + matches.map(function (p, i) { return resultRowHTML(p, i, products, showMatch, t); }).join('') + '</div>' +
      '<div class="ff-results-foot">' +
        '<div class="ff-results-note">' + resultsNote + '</div>' +
        '<button class="ff-restart" type="button" data-ff-restart><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg><span class="ff-restart-text">' + restartLabel + '</span></button>' +
      '</div>';
  }

  function placeholderHTML() {
    return '<div class="ff-b-placeholder">' +
      '<div class="ff-b-placeholder-mark">FLORAÏKU<small>PARIS</small></div>' +
      '<div class="ff-b-placeholder-label">\u2014 Your sillage \u2014</div>' +
      '<p class="ff-b-placeholder-text">Your three fragrances will appear here, ranked by olfactory affinity.</p>' +
    '</div>';
  }

  function FragranceFinder(root) {
    var el = this;
    el.root     = root;
    el.variant  = root.dataset.variant  || 'a';
    el.overline        = root.dataset.overline        || 'Fragrance Finder';
    el.heading         = root.dataset.heading         || 'Which notes move you?';
    el.resultsHeading  = root.dataset.resultsHeading  || 'Your 3 Floraïku';
    el.restartLabel    = root.dataset.restartLabel    || 'Start again';
    el.ctaUrl          = root.dataset.ctaUrl          || '';
    el.ctaLabel        = root.dataset.ctaLabel        || 'Discover these fragrances';
    el.selected = [];
    var sid = root.dataset.sectionId || '';
    var descTpl = document.getElementById('ff-desc-' + sid);
    el.description = descTpl ? descTpl.innerHTML.trim() : '';
    var noteTpl = document.getElementById('ff-results-note-' + sid);
    el.resultsNote = noteTpl ? noteTpl.innerHTML.trim() : '<p>Not sure yet? Receive a free sample with your order to try before you commit.</p>';
    // Parse the products metafield JSON FIRST so el.products is available
    // when we build el.perfumes below. (build-id: og-fix-1)
    var productEl = document.getElementById('ff-products-' + sid);
    try { el.products = productEl ? JSON.parse(productEl.textContent) : {}; }
    catch (e) { el.products = {}; }
    // Locale-aware translations injected by Liquid via locales/{lang}.json
    var i18nEl = document.getElementById('ff-i18n-' + sid);
    var i18n = {};
    try { i18n = i18nEl ? JSON.parse(i18nEl.textContent || '{}') : {}; } catch (e) { i18n = {}; }
    // Build a localized FAMILIES copy (don't mutate the global so re-init stays clean)
    el.families = FAMILIES.map(function (f) {
      var t = i18n.families && i18n.families[f.id];
      return t ? { id: f.id, label: t.label || f.label, hint: t.hint || f.hint } : f;
    });
    // Notes come from the product metafield (auto-localized by Shopify) when
    // available — that's the single source of truth, edited per-product in the
    // admin. If the metafield is empty for a given product, fall back to the
    // hardcoded EN notes baked into PERFUMES. Taglines are NEVER translated.
    el.perfumes = buildPerfumesFromProducts(el.products);
    // UI strings
    el.t = {
      multipleChoices: i18n.multipleChoices || 'Multiple choices possible',
      familySingular:  i18n.familySingular  || 'family selected',
      familyPlural:    i18n.familyPlural    || 'families selected',
      forPreposition:  i18n.forPreposition  || 'For',
      match:           i18n.match           || 'Match',
      revealAria:      i18n.revealAria      || 'Reveal my fragrances'
    };
    el._buildVersion = 'og-fix-1-2026-04-29';
    el._render();
  }

  FragranceFinder.prototype._render = function () {
    var self = this;
    if (self.variant === 'b') {
      self.root.innerHTML = '<div class="ff-inner"><div class="ff-widget ff-b"><div class="ff-b-left" data-ff-quiz></div><div class="ff-b-right" data-ff-side></div></div></div>';
      self.quizEl = self.root.querySelector('[data-ff-quiz]');
      self.sideEl = self.root.querySelector('[data-ff-side]');
      self._renderQuiz();
      self.sideEl.innerHTML = placeholderHTML();
    } else {
      self.root.innerHTML = '<div class="ff-inner"><div class="ff-widget ff-' + self.variant + '" data-ff-inner></div></div>';
      self.innerEl = self.root.querySelector('[data-ff-inner]');
      self._renderQuiz();
    }
  };

  FragranceFinder.prototype._renderQuiz = function () {
    var self = this;
    var container = self.variant === 'b' ? self.quizEl : self.innerEl;
    container.innerHTML = quizHTML(self.overline, self.heading, self.description, self.selected, self.families, self.t);
    container.querySelector('[data-ff-submit]').addEventListener('click', function () { self._submit(); });
    container.querySelectorAll('.ff-card').forEach(function (card) {
      card.addEventListener('click', function () { self._toggle(card.dataset.familyId); });
    });
  };

  FragranceFinder.prototype._toggle = function (id) {
    var idx = this.selected.indexOf(id);
    if (idx === -1) { this.selected.push(id); } else { this.selected.splice(idx, 1); }
    this._updateQuizState();
  };

  FragranceFinder.prototype._updateQuizState = function () {
    var self = this;
    var container = self.variant === 'b' ? self.quizEl : self.innerEl;
    container.querySelectorAll('.ff-card').forEach(function (card) {
      var on = self.selected.indexOf(card.dataset.familyId) !== -1;
      card.classList.toggle('is-on', on);
      card.setAttribute('aria-pressed', String(on));
      var icon = card.querySelector('.ff-card-check-icon');
      if (icon) icon.style.opacity = on ? '1' : '0';
    });
    var count = self.selected.length;
    var countEl = container.querySelector('.ff-count');
    if (countEl) countEl.innerHTML = '<strong>' + count + '</strong> ' + (count === 1 ? self.t.familySingular : self.t.familyPlural);
    var btn = container.querySelector('[data-ff-submit]');
    if (btn) btn.disabled = count === 0;
  };

  FragranceFinder.prototype._submit = function () {
    var self = this;
    var matches = computeMatches(self.selected, 3, self.perfumes);
    var needed = matches.filter(function (m) { return !self.products[m.handle]; });
    if (needed.length === 0) {
      self._showResults(matches);
      return;
    }
    var done = 0;
    needed.forEach(function (m) {
      fetch('/products/' + m.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p) {
            self.products[m.handle] = {
              url: '/products/' + m.handle,
              image: p.images && p.images[0] ? p.images[0].src.replace(/_([\d]+x[\d]*)\./, '_400x.') : '',
              title: p.title
            };
          }
        })
        .catch(function () {})
        .then(function () {
          done++;
          if (done === needed.length) self._showResults(matches);
        });
    });
  };

  FragranceFinder.prototype._showResults = function (matches) {
    var self = this;
    var html = resultsHTML(self.overline, self.selected, matches, self.ctaUrl, self.ctaLabel, self.products, self.variant === 'b', self.resultsHeading, self.restartLabel, self.resultsNote, self.families, self.t);
    var container = self.variant === 'b' ? self.sideEl : self.innerEl;
    container.innerHTML = html;
    var restartBtn = container.querySelector('[data-ff-restart]');
    if (restartBtn) restartBtn.addEventListener('click', function () { self._restart(); });
    // Scroll to the top of the widget after results render. Important on mobile,
    // where the user has just tapped the reveal button at the bottom of the quiz —
    // they would otherwise stay anchored at the bottom and miss the results header.
    try {
      var rect = self.root.getBoundingClientRect();
      var top = (window.pageYOffset || document.documentElement.scrollTop) + rect.top - 16;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    } catch (e) {}
  };

  FragranceFinder.prototype._restart = function () {
    this.selected = [];
    this._render();
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-ff-root]').forEach(function (el) {
      if (!el.dataset.ffInit) {
        el.dataset.ffInit = '1';
        new FragranceFinder(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ff-root]');
    if (root) { delete root.dataset.ffInit; new FragranceFinder(root); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
